module.exports = __webpack_public_path__ + "static/offices-content-image-22_new@2x-2022f11d3f74b93dbf3aac8dc04ee715.jpg";